export default {
  path: '/tool_heads',
  name: 'tool_heads',
  component: () => import('../components/toolhead/Layout'),
  redirect: { name: 'ToolHeadList' },
  meta: {
    breadcrumb: 'profile.tool.toolheads',
  },
  children: [
    {
      name: 'ToolHeadList',
      path: '',
      component: () => import('../views/toolhead/List'),
      meta: {
        breadcrumb: 'global.list',
      },
    },
    {
      name: 'ToolHeadCreate',
      path: 'new',
      component: () => import('../views/toolhead/Create'),
      meta: {
        breadcrumb: 'global.add',
      },
    },
    {
      name: 'ToolHeadUpdate',
      path: ':id/edit',
      component: () => import('../views/toolhead/Update'),
      meta: {
        breadcrumb: 'profile.tool.toolhead',
      },
    },
    {
      name: 'ToolHeadShow',
      path: ':id',
      component: () => import('../views/toolhead/Show'),
      meta: {
        breadcrumb: 'profile.tool.toolhead',
      },
    },
    {
      name: 'ToolHead',
      path: ':parent',
      component: () => import('../components/toolheadsub/Layout'),
      meta: {
        breadcrumb: 'profile.tool.toolhead',
      },
      children: [
        {
          name: 'ToolHeadSubShow',
          path: ':id',
          component: () => import('../views/toolheadsub/Show'),
          meta: {
            breadcrumb: 'profile.tool.toolheadsub',
          },
        },
        {
          name: 'ToolHeadSubUpdate',
          path: ':id/edit',
          component: () => import('../views/toolheadsub/Update'),
          meta: {
            breadcrumb: 'profile.tool.toolheadsub',
          },
        },
        {
          name: 'ToolHeadSubCreate',
          path: 'new',
          component: () => import('../views/toolheadsub/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
    {
      name: 'ToolHeadFile',
      path: ':parent',
      component: () => import('../components/producttypefile/Layout'),
      meta: {
        breadcrumb: 'qualitycheck.product.producttypefiles',
      },
      children: [
        {
          name: 'ProducttypefileToolHeadCreate',
          path: 'new',
          component: () => import('../views/producttypefile/Create'),
          meta: {
            breadcrumb: 'global.add',
          },
        },
      ]

    },
  ]
};
